import { render, staticRenderFns } from "./export-companies-with-invoices.vue?vue&type=template&id=22af0f30&"
import script from "./export-companies-with-invoices.vue?vue&type=script&lang=js&"
export * from "./export-companies-with-invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports